const en = {
  www: 'https://www.bitmain.com',
  antminer: 'https://shop.bitmain.com',
  support: 'https://support.bitmain.com/hc/en-us/requests/new',
  training: 'https://training.bitmain.com',
  blog: 'https://blog.bitmain.com/en',
  job: 'https://jobs.bitmain.com',
  antpool: 'https://v3.antpool.com',
  bitfufu: 'https://www.bitfufu.com',
  antalpha: 'https://www.antalpha.com',
  coupon:'https://my.bitmain.com/user/couponGuide',
  sso: 'https://account.bitmain.com?locale=en',
  ssoLogin: 'https://account.bitmain.com/sign_in?locale=en',
  ssoLogout: 'https://account.bitmain.com/logout?locale=en',
  ssoRegister: 'https://account.bitmain.com/sign_out?locale=en',
  kyc: 'https://account-kyc.bitmain.com?lang=en',
  news: 'https://www.bitmain.com/news',
  mining101: 'https://www.bitmain.com/miningScience',
  globalRepairSites:'https://shop.bitmain.com/support/maintenanceOutlets?module=global',
  h5globalRepairSites:'https://m.bitmain.com/support/maintenanceOutlets?module=global',
  dataCenterCooperation:'https://www.bitmain.com/hosting',
  wdms: 'https://www.bitmain.com/wdms',
  pow: 'https://www.bitmain.com/pow',
  contactSales: 'https://www.bitmain.com/service/contactSales',
  contactUs: 'https://www.bitmain.com/service/contactSales',
  disclaimer: 'https://www.bitmain.com/disclaimer',
  privacy: 'https://www.bitmain.com/privacy',
  facebook: 'https://www.facebook.com/Bitmain',
  twitter: 'https://twitter.com/BITMAINtech',
  youtube: 'https://www.youtube.com/c/Bitmain_official',
  telegram: 'https://t.me/bitmain',
  reddit: 'https://www.reddit.com/r/BITMAIN',
  email: 'https://my.bitmain.com/user/subScription?edit=true',
  bitAccounts: 'https://www.bitmain.com/service/bitAccounts',
  calc: 'https://service.bitmain.com/support/calculator',
  order: 'https://order.bitmain.com',
  orderSn: 'https://service.bitmain.com/support/searchsn',
  orderState: 'https://my.bitmain.com/user/salesOrder',
  download: 'https://service.bitmain.com/support/download',
  saleTerms: 'https://service.bitmain.com/support/policy',
  sendRepair: 'https://service.bitmain.com/repair/create',
  warranty: 'https://service.bitmain.com/support/warranty',
  supportTerms: 'https://service.bitmain.com/support/terms',
  apply: 'https://service.bitmain.com/support/apply/create',
  manual: 'https://service.bitmain.com/support/productManual',
  userGuide: 'https://service.bitmain.com/support/productUserManual',
  experienced: 'https://jobs.bitmain.com/experienced',
  students: 'https://jobs.bitmain.com/students',
  trainee: 'https://jobs.bitmain.com/trainee',
  ANTforum:'https://forum.bitmain.com',
  hAntminer: 'https://m.bitmain.com',
  hManual: 'https://m.bitmain.com/support/download',
  hCalc: 'https://m.bitmain.com/support/calculator',
  hOrderSn: 'https://m.bitmain.com/support/searchsn',
  hOrderState: 'https://m.bitmain.com/user/orders',
  hSaleTerms: 'https://m.bitmain.com/support/policy',
  hSendRepair: 'https://m.bitmain.com/repair/issue?type=0',
  hWarranty: 'https://m.bitmain.com/support/warranty',
  hApply: 'https://m.bitmain.com/repair/apply/create',
  hSupportTerms: 'https://m.bitmain.com/support/terms',
  hbk: 'https://www.bitmain.com/bulkOrder',
  buyingParts: 'https://shop.bitmain.com/product/parts',
  buyingMaterials: 'https://shop.bitmain.com/product/materials',
  productCertificate: 'https://service.bitmain.com/support/productCertificatey',
  packageTracking: 'https://service.bitmain.com/support/tracking',
  repairGuide: 'https://service.bitmain.com/support/guide',
  hBuyingParts: 'https://m.bitmain.com/product/parts',
  hBuyingMaterials: 'https://m.bitmain.com/product/materials',
  hProductCertificate: 'https://support.bitmain.com/hc/en-us/sections/205442888-Certificate',
  hPackageTracking: 'https://m.bitmain.com/support/tracking',
  hRepairGuide: 'https://m.bitmain.com/support/guide',
  profitCalculator: 'https://www.bitmain.com/calculator',
  miningFarm: 'https://www.bitmain.com/miningFarm',
  mycenter: 'https://my.bitmain.com/user/myAccount',
  hMycenter: 'https://m.bitmain.com/user',
  shopService: 'https://shop-product-service.bitmain.com',
  repairSite: 'https://shop.bitmain.com/support/maintenanceOutlets',
  firewareDownload: 'https://shop.bitmain.com/support/download',
  customerSupport: 'https://service.bitmain.com/support',
  hcustomerSupport: 'https://m.bitmain.com/support',
  hFirewareDownload: 'https://m.bitmain.com/support/download',
  hRepairSite: 'https://support.bitmain.com/hc/en-us/articles/220138027-Global-Repair-Site-Delivery-Addresses-Official-',
};

const zh = {
  www: 'https://www.bitmain.com/zh',
  antminer: 'https://shop.bitmain.com/zh',
  support: 'https://support.bitmain.com/hc/zh-cn/requests/new',
  coupon: 'https://my.bitmain.com/zh/user/couponGuide',
  training: 'https://training.bitmain.com.cn',
  blog: 'https://blog.bitmain.com/cn',
  job: 'https://jobs.bitmain.com.cn',
  antpool: 'https://v3.antpool.com?language=zh',
  bitfufu: 'https://www.bitfufu.com',
  antalpha: 'https://www.antalpha.com',
  sso: 'https://account.bitmain.com?locale=zh',
  ssoLogin: 'https://account.bitmain.com/sign_in?locale=zh',
  ssoLogout: 'https://account.bitmain.com/logout?locale=zh',
  ssoRegister: 'https://account.bitmain.com/sign_out?locale=zh',
  kyc: 'https://account-kyc.bitmain.com?lang=zh',
  news: 'https://www.bitmain.com/zh/news',
  mining101: 'https://www.bitmain.com/zh/miningScience',
  dataCenterCooperation:'https://www.bitmain.com/zh/hosting',
  contactSales: 'https://www.bitmain.com/zh/service/contactSales',
  contactUs: 'https://www.bitmain.com/zh/service/contactSales',
  wdms: 'https://www.bitmain.com/zh/wdms',
  pow: 'https://www.bitmain.com/zh/pow',
  globalRepairSites:'https://shop.bitmain.com/zh/support/maintenanceOutlets?module=global',
  h5globalRepairSites:'https://m.bitmain.com/zh/support/maintenanceOutlets?module=global',
  disclaimer: 'https://www.bitmain.com/zh/disclaimer',
  privacy: 'https://www.bitmain.com/zh/privacy',
  facebook: 'https://www.facebook.com/Bitmain',
  twitter: 'https://twitter.com/BITMAINtech',
  youtube: 'https://www.youtube.com/c/Bitmain_official',
  telegram: 'https://t.me/bitmain',
  reddit: 'https://www.reddit.com/r/BITMAIN',
  email: 'https://my.bitmain.com/user/subScription?edit=true',
  bitAccounts: 'https://www.bitmain.com/zh/service/bitAccounts',
  calc: 'https://service.bitmain.com/zh/support/calculator',
  order: 'https://order.bitmain.com/zh',
  orderSn: 'https://service.bitmain.com/zh/support/searchsn',
  orderState: 'https://my.bitmain.com/zh/user/salesOrder',
  download: 'https://service.bitmain.com/zh/support/download',
  saleTerms: 'https://service.bitmain.com/zh/support/policy',
  sendRepair: 'https://service.bitmain.com/zh/repair/create',
  warranty: 'https://service.bitmain.com/zh/support/warranty',
  supportTerms: 'https://service.bitmain.com/zh/support/terms',
  apply: 'https://service.bitmain.com/zh/support/apply/create',
  manual: 'https://service.bitmain.com/zh/support/productManual',
  userGuide:'https://service.bitmain.com/zh/support/productUserManual',
  experienced: 'https://jobs.bitmain.com.cn/experienced',
  students: 'https://jobs.bitmain.com.cn/students',
  trainee: 'https://jobs.bitmain.com.cn/trainee',
  ANTforum:'https://forum.bitmain.com.cn',
  hAntminer: 'https://m.bitmain.com/zh',
  hManual: 'https://m.bitmain.com/zh/support/download',
  hCalc: 'https://m.bitmain.com/zh/support/calculator',
  hOrderSn: 'https://m.bitmain.com/zh/support/searchsn',
  hOrderState: 'https://m.bitmain.com/zh/user/orders',
  hSaleTerms: 'https://m.bitmain.com/zh/support/policy',
  hSendRepair: 'https://m.bitmain.com/zh/repair/issue?type=0',
  hWarranty: 'https://m.bitmain.com/zh/support/warranty',
  hApply: 'https://m.bitmain.com/zh/repair/apply/create',
  hSupportTerms: 'https://m.bitmain.com/zh/support/terms',
  hbk: 'https://www.bitmain.com/zh/bulkOrder',
  buyingParts: 'https://shop.bitmain.com/zh/product/parts',
  buyingMaterials: 'https://shop.bitmain.com/zh/product/materials',
  productCertificate: 'https://service.bitmain.com/zh/support/productCertificatey',
  packageTracking: 'https://service.bitmain.com/zh/support/tracking',
  repairGuide: 'https://service.bitmain.com/zh/support/guide',
  hBuyingParts: 'https://m.bitmain.com/zh/product/parts',
  hBuyingMaterials: 'https://m.bitmain.com/zh/product/materials',
  hProductCertificate: 'https://support.bitmain.com/hc/en-us/sections/205442888-Certificate',
  hPackageTracking: 'https://m.bitmain.com/zh/support/tracking',
  hRepairGuide: 'https://m.bitmain.com/zh/support/guide',
  profitCalculator: 'https://www.bitmain.com/zh/calculator',
  miningFarm: 'https://www.bitmain.com/zh/miningFarm',
  mycenter: 'https://my.bitmain.com/zh/user/myAccount',
  hMycenter: 'https://m.bitmain.com/zh/user',
  shopService: 'https://shop-product-service.bitmain.com',
  repairSite: 'https://shop.bitmain.com/zh/support/maintenanceOutlets',
  firewareDownload: 'https://shop.bitmain.com/zh/support/download',
  hFirewareDownload: 'https://m.bitmain.com/zh/support/download',
  customerSupport: 'https://service.bitmain.com/zh/support',
  hcustomerSupport: 'https://m.bitmain.com/zh/support',
  hRepairSite: 'https://support.bitmain.com/hc/en-us/articles/220138027-Global-Repair-Site-Delivery-Addresses-Official-',
};

const enBeta = {
  www: 'https://www-beta.bitmain.com',
  antminer: 'https://beta.bitmain.com',
  support: 'https://support.bitmain.com/hc/en-us/requests/new',
  coupon: 'https://shop-user-beta.bitmain.com/user/couponGuide',
  training: 'https://training-beta.bitmain.com',
  blog: 'https://blog.bitmain.com/en',
  job: 'https://jobs-beta.bitmain.com',
  antpool: 'https://v3.antpool.com',
  bitfufu: 'https://www.bitfufu.com',
  antalpha: 'https://www.antalpha.com',
  sso: 'https://account-beta.bitmain.com?locale=en',
  ssoLogin: 'https://account-beta.bitmain.com/sign_in?locale=en',
  ssoLogout: 'https://account-beta.bitmain.com/logout?locale=en',
  ssoRegister: 'https://account-beta.bitmain.com/sign_out?locale=en',
  kyc: 'http://8.210.15.99:3011?lang=en',
  news: 'https://www-beta.bitmain.com/news',
  mining101: 'https://www-beta.bitmain.com/miningScience',
  dataCenterCooperation:'https://www-beta.bitmain.com/hosting',
  contactSales: 'https://www-beta.bitmain.com/service/contactSales',
  contactUs: 'https://www-beta.bitmain.com/service/contactSales',
  wdms: 'https://www-beta.bitmain.com/wdms',
  pow: 'https://www-beta.bitmain.com/pow',
  globalRepairSites:'https://beta.bitmain.com/support/maintenanceOutlets?module=global',
  h5globalRepairSites:'https://shop-m-beta.bitmain.com/support/maintenanceOutlets?module=global',
  disclaimer: 'https://www-beta.bitmain.com/disclaimer',
  privacy: 'https://www-beta.bitmain.com/privacy',
  facebook: 'https://www.facebook.com/Bitmain',
  twitter: 'https://twitter.com/BITMAINtech',
  youtube: 'https://www.youtube.com/c/Bitmain_official',
  telegram: 'https://t.me/bitmain',
  reddit: 'https://www.reddit.com/r/BITMAIN',
  email: 'https://my.bitmain.com/user/subScription?edit=true',
  bitAccounts: 'https://www-beta.bitmain.com/service/bitAccounts',
  calc: 'https://service-beta.bitmain.com/support/calculator',
  order: 'https://shop-order-beta.bitmain.com/user/orderDetails',
  orderSn: 'https://service-beta.bitmain.com/support/searchsn',
  orderState: 'https://my.bitmain.com/user/salesOrder',
  download: 'https://service-beta.bitmain.com/support/download',
  saleTerms: 'https://service-beta.bitmain.com/support/policy',
  sendRepair: 'https://service-beta.bitmain.com/repair/create',
  warranty: 'https://service-beta.bitmain.com/support/warranty',
  supportTerms: 'https://service-beta.bitmain.com/support/terms',
  apply: 'https://service-beta.bitmain.com/support/apply/create',
  manual: 'https://service-beta.bitmain.com/support/productManual',
  userGuide: 'https://service-beta.bitmain.com/support/productUserManual',
  experienced: 'https://jobs-beta.bitmain.com/experienced',
  students: 'https://jobs-beta.bitmain.com/students',
  trainee: 'https://jobs-beta.bitmain.com/trainee',
  ANTforum:'https://forum-beta.bitmain.com',
  hAntminer: 'https://shop-m-beta.bitmain.com',
  hManual: 'https://shop-m-beta.bitmain.com/support/download',
  hCalc: 'https://shop-m-beta.bitmain.com/support/calculator',
  hOrderSn: 'https://shop-m-beta.bitmain.com/support/searchsn',
  hOrderState: 'https://shop-m-beta.bitmain.com/user/orders',
  hSaleTerms: 'https://shop-m-beta.bitmain.com/support/policy',
  hSendRepair: 'https://shop-m-beta.bitmain.com/repair/issue?type=0',
  hWarranty: 'https://shop-m-beta.bitmain.com/support/warranty',
  hApply: 'https://shop-m-beta.bitmain.com/repair/apply/create',
  hSupportTerms: 'https://shop-m-beta.bitmain.com/support/terms',
  hbk: 'https://www-beta.bitmain.com/bulkOrder',
  buyingParts: 'https://beta.bitmain.com/product/parts',
  buyingMaterials: 'https://beta.bitmain.com/product/materials',
  productCertificate: 'https://service-beta.bitmain.com/support/productCertificatey',
  packageTracking: 'https://service.bitmain.com/support/tracking',
  repairGuide: 'https://service.bitmain.com/support/guide',
  hBuyingParts: 'https://shop-m-beta.bitmain.com/product/parts',
  hBuyingMaterials: 'https://shop-m-beta.bitmain.com/product/materials',
  hProductCertificate: 'https://support.bitmain.com/hc/en-us/sections/205442888-Certificate',
  hPackageTracking: 'https://shop-m-beta.bitmain.com/support/tracking',
  hRepairGuide: 'https://shop-m-beta.bitmain.com/support/guide',
  profitCalculator: 'https://www-beta.bitmain.com/calculator',
  miningFarm: 'https://www-beta.bitmain.com/miningFarm',
  mycenter: 'https://shop-user-beta.bitmain.com/user/myAccount',
  hMycenter: 'https://shop-m-beta.bitmain.com/user',
  shopService: 'https://shop-product-beta.bitmain.com',
  repairSite: 'https://beta.bitmain.com/support/maintenanceOutlets',
  firewareDownload: 'https://beta.bitmain.com/support/download',
  hFirewareDownload: 'https://shop-m-beta.bitmain.com/support/download',
  customerSupport: 'https://service-beta.bitmain.com/support',
  hcustomerSupport: 'https://shop-m-beta.bitmain.com/support',
  hRepairSite: 'https://support.bitmain.com/hc/en-us/articles/220138027-Global-Repair-Site-Delivery-Addresses-Official-',
};

const zhBeta = {
  www: 'https://www-beta.bitmain.com/zh',
  antminer: 'https://beta.bitmain.com/zh',
  support: 'https://support.bitmain.com/hc/zh-cn/requests/new',
  training: 'https://training-beta.bitmain.com.cn',
  coupon: 'https://shop-user-beta.bitmain.com/zh/user/couponGuide',
  blog: 'https://blog.bitmain.com/cn',
  job: 'https://jobs-beta.bitmain.com.cn',
  antpool: 'https://v3.antpool.com?language=zh',
  bitfufu: 'https://www.bitfufu.com',
  antalpha: 'https://www.antalpha.com',
  sso: 'https://account-beta.bitmain.com?locale=zh',
  ssoLogin: 'https://account-beta.bitmain.com/sign_in?locale=zh',
  ssoLogout: 'https://account-beta.bitmain.com/logout?locale=zh',
  ssoRegister: 'https://account-beta.bitmain.com/sign_out?locale=zh',
  kyc: 'http://8.210.15.99:3011/?lang=zh',
  news: 'https://www-beta.bitmain.com/zh/news',
  mining101: 'https://www-beta.bitmain.com/zh/miningScience',
  dataCenterCooperation:'https://www-beta.bitmain.com/zh/hosting',
  contactSales: 'https://www-beta.bitmain.com/zh/service/contactSales',
  contactUs: 'https://www-beta.bitmain.com/zh/service/contactSales',
  wdms: 'https://www-beta.bitmain.com/zh/wdms',
  pow: 'https://www-beta.bitmain.com/zh/pow',
  globalRepairSites:'https://beta.bitmain.com/zh/support/maintenanceOutlets?module=global',
  h5globalRepairSites:'https://shop-m-beta.bitmain.com/zh/support/maintenanceOutlets?module=global',
  disclaimer: 'https://www-beta.bitmain.com/zh/disclaimer',
  privacy: 'https://www-beta.bitmain.com/zh/privacy',
  facebook: 'https://www.facebook.com/Bitmain',
  twitter: 'https://twitter.com/BITMAINtech',
  youtube: 'https://www.youtube.com/c/Bitmain_official',
  telegram: 'https://t.me/bitmain',
  reddit: 'https://www.reddit.com/r/BITMAIN',
  email: 'https://my.bitmain.com/user/subScription?edit=true',
  bitAccounts: 'https://www-beta.bitmain.com/zh/service/bitAccounts',
  calc: 'https://service-beta.bitmain.com/zh/support/calculator',
  order: 'https://shop-order-beta.bitmain.com/zh/user/orderDetails',
  orderSn: 'https://service-beta.bitmain.com/zh/support/searchsn',
  orderState: 'https://my.bitmain.com/zh/user/salesOrder',
  download: 'https://service-beta.bitmain.com/zh/support/download',
  saleTerms: 'https://service-beta.bitmain.com/zh/support/policy',
  sendRepair: 'https://service-beta.bitmain.com/zh/repair/create',
  warranty: 'https://service-beta.bitmain.com/zh/support/warranty',
  supportTerms: 'https://service-beta.bitmain.com/zh/support/terms',
  apply: 'https://service-beta.bitmain.com/zh/support/apply/create',
  manual: 'https://service-beta.bitmain.com/zh/support/productManual',
  userGuide: 'https://service-beta.bitmain.com/zh/support/productUserManual',
  experienced: 'https://jobs-beta.bitmain.com.cn/experienced',
  students: 'https://jobs-beta.bitmain.com.cn/students',
  trainee: 'https://jobs-beta.bitmain.com.cn/trainee',
  ANTforum:'https://forum-beta.bitmain.com.cn',
  hAntminer: 'https://shop-m-beta.bitmain.com/zh',
  hManual: 'https://shop-m-beta.bitmain.com/zh/support/download',
  hCalc: 'https://shop-m-beta.bitmain.com/zh/support/calculator',
  hOrderSn: 'https://shop-m-beta.bitmain.com/zh/support/searchsn',
  hOrderState: 'https://shop-m-beta.bitmain.com/zh/user/orders',
  hSaleTerms: 'https://shop-m-beta.bitmain.com/zh/support/policy',
  hSendRepair: 'https://shop-m-beta.bitmain.com/zh/repair/issue?type=0',
  hWarranty: 'https://shop-m-beta.bitmain.com/zh/support/warranty',
  hApply: 'https://shop-m-beta.bitmain.com/zh/repair/apply/create',
  hSupportTerms: 'https://shop-m-beta.bitmain.com/zh/support/terms',
  hbk: 'https://www-beta.bitmain.com/zh/bulkOrder',
  buyingParts: 'https://beta.bitmain.com/zh/product/parts',
  buyingMaterials: 'https://beta.bitmain.com/zh/product/materials',
  productCertificate: 'https://service-beta.bitmain.com/zh/support/productCertificatey',
  packageTracking: 'https://service.bitmain.com/zh/support/tracking',
  repairGuide: 'https://service.bitmain.com/zh/support/guide',
  hBuyingParts: 'https://shop-m-beta.bitmain.com/zh/product/parts',
  hBuyingMaterials: 'https://shop-m-beta.bitmain.com/zh/product/materials',
  hProductCertificate: 'https://support.bitmain.com/hc/en-us/sections/205442888-Certificate',
  hPackageTracking: 'https://shop-m-beta.bitmain.com/zh/support/tracking',
  hRepairGuide: 'https://shop-m-beta.bitmain.com/zh/support/guide',
  profitCalculator: 'https://www-beta.bitmain.com/zh/calculator',
  miningFarm: 'https://www-beta.bitmain.com/zh/miningFarm',
  mycenter: 'https://shop-user-beta.bitmain.com/zh/user/myAccount',
  hMycenter: 'https://shop-m-beta.bitmain.com/zh/user',
  shopService: 'https://shop-product-beta.bitmain.com',
  repairSite: 'https://beta.bitmain.com/zh/support/maintenanceOutlets',
  firewareDownload: 'https://beta.bitmain.com/zh/support/download',
  hFirewareDownload: 'https://shop-m-beta.bitmain.com/zh/support/download',
  customerSupport: 'https://service-beta.bitmain.com/zh/support',
  hcustomerSupport: 'https://shop-m-beta.bitmain.com/zh/support',
  hRepairSite: 'https://support.bitmain.com/hc/en-us/articles/220138027-Global-Repair-Site-Delivery-Addresses-Official-',
};

export default { en, zh, enBeta, zhBeta };
